import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/StyledElements";
import { useAuthContext } from "../../../contexts/AuthContext";
import { useCourseContext } from "../../../contexts/CoursesContext";


const SmallButton = styled.div`
  height: 30px;
  width: 24px;
  background-color: #f3f4f6; 
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0a6b1;
  cursor: pointer;

  &.selected {
    background-color: var(--button-selected-bg); 
  }
  &.selected > * {
    color: var(--button-bg);

  }
`

const VerticalSeparator = styled.div`
  width: 1px;
  height: 30px;
  background-color: #eceff4;
  margin-left: 20px;
  margin-right: 20px;
`

const CourseLevelsGridWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

`

const CourseLevelCardWrapper = styled.div`
    position: relative;
    border: 1px solid var(--content-item-border-color);
    color: var(--main-font-color);
    width: 330px;
    background-color: var(--card-bg);
    border-radius: 5px;
    box-shadow: var(--content-item-box-shadow);
    padding: 20px 20px 0 20px;
`


const CourseLevelTitle = styled.div`
    font-weight: bold;
    font-size: 20px;
    margin-top: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    text-wrap: wrap;
`

const CourseDescription = styled.div`
    font-weight: normal;
    font-size: 16px;
    margin-top: 10px;
    font-style: italic;
    overflow: auto;
    max-height: 140px;
    height: 140px;
    margin-bottom: 10px;
`

const CourseLevelData = styled.div`
    position: relative;
    width: 330px;
    margin-left: -20px;
    font-size: 14px;
    color: #a0a6b1;
    background-color: var(--card-inset-bg);
    padding: 10px 20px;
    border-top: 1px solid var(--main-bg);
    border-bottom: 1px solid var(--main-bg);
`;

const CourseOpenLink = styled.a`
    font-size: 15px;
    color: var(--sidebar-active-item-color);
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
`;

const SearchBar = styled.div`
  width: calc(100% - 20px);
  border-radius: 5px;
  border: 1px solid var(--content-item-border-color);  
  background-color: var(--card-bg);
  padding: 10px 20px;
  box-shadow: var(--content-item-box-shadow);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

const SearchBox = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 5px;
  border: 1px solid #d2d6dd;
  background-color: #f8fafb; 
  display: flex;
  align-items: center;
  padding-left: 10px;

  & * {
    color: #717886;
  }

  & input {
    height: 100%;
    border: none;
    outline: none !important;
    background: transparent;
    width: 250px;
  }

  & input:focus {
    outline:none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }
}
`

const CourseLevelToolBarWrapper = styled.div`
  width: 300px;
  margin-left: -20px;
  height: 50px;
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  padding: 0;
`

const CourseLevelToolBarButton = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--main-bg);
  cursor: pointer;

  & * {
    font-size: 20px;
 }

`;

export const CourseLevels = ({ style = {} }) => {
  const { activeUser } = useAuthContext();
  const isAdmin = activeUser?.user_type.includes("admin");
  const [filteredCourseLevels, setFilteredCourseLevels] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("newest-first")
  const [display, setDisplay] = useState("grid");
  const navigate = useNavigate();

  const { updatedCourse } = useCourseContext();

  const sortByOptions = [
    { label: "Newest First", value: "newest-first" },
    { label: "Open Date First", value: "open-date-first" },
    { label: "Open Date Last", value: "open-date-last" },
    { label: "Start Date First", value: "start-date-first" },
    { label: "Start Date Last", value: "start-date-last" },
  ]

  useEffect(() => {
    console.log("!!! FETCHING COURSES");
    setFilteredCourseLevels(updatedCourse?.levels || []);

    // eslint-disable-next-line
  }, [updatedCourse?.levels]);


  useEffect(() => {
    if (!searchTerm) {
      setFilteredCourseLevels(updatedCourse?.levels || []);
      return;
    }

    setFilteredCourseLevels(updatedCourse?.levels.filter((courseLevel) => {
      console.log(courseLevel.title, courseLevel.description)
      return `${courseLevel.status} ${courseLevel.title} ${courseLevel.description}`.toLowerCase().includes(searchTerm.toLowerCase())
    }))

    // eslint-disable-next-line
  }, [searchTerm, updatedCourse?.levels])

  const CourseLevelToolBar = ({ courseLevel }) => {
    return (
      <CourseLevelToolBarWrapper>
        {/* Toolbar buttons can be added here */}
        <CourseLevelToolBarButton><Icon icon="mdi:link" /></CourseLevelToolBarButton>
      </CourseLevelToolBarWrapper>
    )
  }

  const CourseLevelCard = ({ courseLevel }) => {
    return (
      <CourseLevelCardWrapper key={courseLevel.id}>
        <div style={{ height: "240px", minHeight: "240px" }}>
          <CourseLevelTitle
            title={`${courseLevel?.level_number}. ${courseLevel?.title}`}
          >{courseLevel?.level_number}. {courseLevel?.title}</CourseLevelTitle>
          <CourseDescription>{courseLevel?.description ?? "No course level description"}</CourseDescription>
        </div>


        <CourseLevelData>
          <div>ID: {courseLevel.id}</div>
          <div>PUB: {courseLevel.public_id.substr(0, 8)}...</div>
          <div>Sections: {courseLevel.section_count}</div>
          <div style={{ position: "absolute", right: "20px", top: "10px", fontSize: "12px", color: "#a0a6b1" }}>
            <CourseOpenLink onClick={() => {
              const { public_id } = courseLevel;
              navigate(`/courselevel/${public_id}`);
            }}>
              View <Icon icon="mdi:open-in-new" style={{ marginLeft: "5px" }} />
            </CourseOpenLink>
          </div>
        </CourseLevelData>
        <CourseLevelToolBar courseLevel={courseLevel} />
      </CourseLevelCardWrapper>
    )
  }

  const CourseLevelsGrid = () => {
    console.log("!!! FILTERED COURSE LEVELS: ", filteredCourseLevels);
    return (
      <CourseLevelsGridWrapper>
        {filteredCourseLevels.map(courseLevel => {
          return <div key={courseLevel.id} style={{ marginRight: "24px", marginBottom: "24px" }}><CourseLevelCard courseLevel={courseLevel} /></div>
        })
        }
      </CourseLevelsGridWrapper>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", position: "relative", ...style }}>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        <div style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>Manage Course Levels  <span style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>({updatedCourse?.levels?.length > filteredCourseLevels.length ? `${filteredCourseLevels.length} of ${updatedCourse?.levels?.length}` : updatedCourse?.levels?.length})</span></div>
      </div>
      {
        isAdmin && (
          <div style={{ position: "absolute", right: "20px", top: "0px" }}>
            <Button
              onClick={() => {
                navigate(`/course/create`);
              }}
            >+ Create Level</Button>
          </div>
        )}

      <div style={{ marginTop: "24px" }}>
        <SearchBar>
          <label style={{ marginRight: "10px", color: "var(--main-font-color)" }}>Sort by: </label>
          <Select
            label="Sort by"
            placeholder="Sort By"
            name="sortby"
            value={
              sortByOptions.find(
                (sb) =>
                  sb.value === sortBy
              )
            }
            options={sortByOptions}
            onChange={(e) => {
              setSortBy(e.value);
            }}
          />
          <VerticalSeparator />

          <SmallButton className={display === "list" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("list") }}>
            <Icon icon="material-symbols:list" />
          </SmallButton>
          <SmallButton className={display === "grid" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("grid") }}>
            <Icon icon="material-symbols:grid-view-outline" />
          </SmallButton>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <SearchBox>
              <Icon icon="material-symbols:search" />
              <input value={searchTerm} type="text" onChange={(e) => {
                setSearchTerm(e.target.value);
              }} />

              {searchTerm &&
                <div style={{ cursor: "pointer" }} onClick={() => setSearchTerm("")}>
                  <Icon icon="material-symbols:x-circle" />
                </div>
              }
            </SearchBox>
          </div>
        </SearchBar>
      </div>

      {
        display === "grid" &&
        <div style={{ marginTop: "24px" }}>
          <CourseLevelsGrid />
        </div>
      }
      {/*
        display === "list" &&
        <CoursesTable
          courses={filteredCourseLevels}
          onUpdated={(newCourses) => {
            setCourses(newCourses);
          }}
        />
      */}
    </div>
  );
};

export default CourseLevels;
